import { List, Record } from 'immutable';
import { THREAD_REMOVAL_TYPE } from './threadRemovalKeyPaths';
import { FILTER_CHANGE } from './threadRemovalTypes';
const FilterChangeRemoval = Record({
  [THREAD_REMOVAL_TYPE]: FILTER_CHANGE,
  audit: null,
  filtered: null,
  members: List()
}, 'FilterChangeRemoval');
export default FilterChangeRemoval;